import React from 'react'
import Header from '../common/Header.js'
import InnerBanner from '../common/InnerBanner.js'
import Footer from '../common/Footer.js'
import { Link } from 'react-router-dom'

export default function HowItsWorks() {
  return (
    <React.Fragment>
      <Header />

      <InnerBanner title="How It Works" />

      <section className="w3l-gallery-25-top">
        <div className="gallery-25">
          <div className="wrapper">

            <h3 className="title-main">How DLMP21 Works</h3>

            <div className="gallery-25-content">

              <div className="d-grid grid-columns">

                {/* STEP 01 */}
                <div className="column">
                  <div className="box13">
                    <Link to="/register">
                      <img
                        className="side-img img-fluid img-responsive"
                        src="assets/images/signup.jpg"
                        alt="Create DLMP21 account"
                      />
                    </Link>
                  </div>
                </div>

                <div className="column two">
                  <div className="box13">
                    <span>01</span>

                    <h3>
                      <Link to="/register">
                        Create Your Account
                      </Link>
                    </h3>

                    <p>
                      Register with DLMP21 by providing your basic details.
                      After registration, your account becomes part of the
                      DLMP21 customer network.
                    </p>

                    <Link
                      to="/register"
                      className="action btn button-eff"
                    >
                      Register Now
                    </Link>
                  </div>
                </div>


                {/* STEP 02 */}
                <div className="column two col1">
                  <div className="box13">
                    <span>02</span>

                    <h3>
                      Get Your DLMP Code
                    </h3>

                    <p>
                      Once your account is created, you receive a unique
                      DLMP Code. Keep this code available when making eligible
                      purchases through participating businesses.
                    </p>

                    <Link
                      to="/login"
                      className="action btn button-eff"
                    >
                      Login
                    </Link>
                  </div>
                </div>

                <div className="column col2">
                  <div className="box13">
                    <Link to="/login">
                      <img
                        className="side-img img-fluid img-responsive"
                        src="assets/images/get-code.jpg"
                        alt="DLMP21 code"
                      />
                    </Link>
                  </div>
                </div>


                {/* STEP 03 */}
                <div className="column">
                  <div className="box13">
                    <Link to="/shops">
                      <img
                        className="side-img img-fluid img-responsive"
                        src="assets/images/service3.jpg"
                        alt="Shop at participating DLMP21 businesses"
                      />
                    </Link>
                  </div>
                </div>

                <div className="column two">
                  <div className="box13">
                    <span>03</span>

                    <h3>
                      <Link to="/shops">
                        Shop ₹1,000+ From Participating Businesses
                      </Link>
                    </h3>

                    <p>
                      Purchase eligible products worth ₹1,000 or more during
                      the applicable monthly period from participating
                      DLMP21 businesses.
                    </p>

                    <Link
                      to="/shops"
                      className="action btn button-eff"
                    >
                      Find Shops
                    </Link>
                  </div>
                </div>


                {/* STEP 04 */}
                <div className="column two col1">
                  <div className="box13">
                    <span>04</span>

                    <h3>
                      Show Your DLMP Code
                    </h3>

                    <p>
                      After completing your eligible purchase, show your
                      DLMP Code to the participating franchisee or business
                      so that the purchase can be recorded on the DLMP21
                      platform.
                    </p>

                    <Link
                      to="/shops"
                      className="action btn button-eff"
                    >
                      Explore Businesses
                    </Link>
                  </div>
                </div>

                <div className="column col2">
                  <div className="box13">
                    <img
                      className="side-img img-fluid img-responsive"
                      src="assets/images/service4.jpg"
                      alt="DLMP21 purchase recording"
                    />
                  </div>
                </div>


                {/* STEP 05 */}
                <div className="column">
                  <div className="box13">
                    <img
                      className="side-img img-fluid img-responsive"
                      src="assets/images/service1.jpg"
                      alt="DLMP21 reward network"
                    />
                  </div>
                </div>

                <div className="column two">
                  <div className="box13">
                    <span>05</span>

                    <h3>
                      Purchase Is Recorded
                    </h3>

                    <p>
                      The participating business records your eligible
                      purchase through the DLMP21 system. Your account can
                      then reflect the applicable purchase and network
                      activity.
                    </p>
                  </div>
                </div>


                {/* STEP 06 */}
                <div className="column two col1">
                  <div className="box13">
                    <span>06</span>

                    <h3>
                      Check Your Network & Eligible Rewards
                    </h3>

                    <p>
                      View your customer network and applicable reward
                      information from your DLMP21 account. Rewards are
                      calculated and processed according to the applicable
                      DLMP21 eligibility and payout rules.
                    </p>

                    <Link
                      to="/commisions"
                      className="action btn button-eff"
                    >
                      View Rewards
                    </Link>
                  </div>
                </div>

                <div className="column col2">
                  <div className="box13">
                    <Link to="/commisions">
                      <img
                        className="side-img img-fluid img-responsive"
                        src="assets/images/service2.jpg"
                        alt="DLMP21 rewards"
                      />
                    </Link>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  )
}